module.exports = __webpack_public_path__ + "img/aperto-de-mao.83356e3d.svg";